import { createEvent, createStore } from 'effector'
import { createGate } from 'effector-react'
import { readonly } from 'patronum'

import { appParams } from '@portal/client-info'

import { isTermsAccepted } from '@/features/terms'

export const showStepLogin = createEvent()
export const showStepSignupPassword = createEvent()
export const showStepSignupEmail = createEvent()
export const showStepEmailMaybeUndeliverable = createEvent()
export const showStepAccountAlreadyExists = createEvent()
export const showStepPasswordTooSimple = createEvent()
export const showStepSignupFailed = createEvent()

export const AuthFormGate = createGate()

export type Step =
    | 'login'
    | 'signup_email'
    | 'signup_password'
    | 'email_maybe_undeliverable'
    | 'account_already_exists'
    | 'signup_error_password_too_simple'
    | 'signup_failed'

const $step = createStore<Step>('signup_email')
    .on(AuthFormGate.open, () => {
        if (appParams['action'] === 'signup') {
            return 'signup_email'
        }

        if (appParams['action'] === 'login') {
            return 'login'
        }

        return isTermsAccepted() ? 'login' : 'signup_email'
    })
    .on(showStepLogin, () => 'login')
    .on(showStepSignupEmail, () => 'signup_email')
    .on(showStepSignupPassword, () => 'signup_password')
    .on(showStepEmailMaybeUndeliverable, () => 'email_maybe_undeliverable')
    .on(showStepAccountAlreadyExists, () => 'account_already_exists')
    .on(showStepPasswordTooSimple, () => 'signup_error_password_too_simple')
    .on(showStepSignupFailed, () => 'signup_failed')

export const $currentStep = readonly($step)
